// extracted by mini-css-extract-plugin
export default {"container":"styles_container__C34F6","wrapper":"styles_wrapper__hj1fV","content":"styles_content__cHHKF","slide":"styles_slide__YFzDs","hoverable":"styles_hoverable__qCIiO"};